<template>
  <div class="modal fade accept_TC" id="accept_TC_popup" tabindex="-1" role="dialog"
       aria-labelledby="" aria-hidden="true" data-backdrop="static" data-keyboard="false">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <button type="button" @click="closeModal()" class="close" data-dismiss="modal"
                aria-label="Close">
          <img src="static/img/millen_images/popup-close.svg" alt="">
        </button>
        <div class="modal-header">
          <h5 class="modal-title">Welkom!</h5>
          <h4>
            Voordat je het spel kunt spelen vragen we je om minimaal akkoord te gaan met de leeftijdscheck en Actievoorwaarden. Wil je weten hoe wij omgaan met je persoonsgegevens, zie onze <a href="https://www.odido.nl/privacy" target="_blank">Privacy statement</a>.
          </h4>
        </div>
        <div class="modal-body">
          <form>
            <!-- Select All Option -->
            <p class="mt-4">
              <input type="radio" id="option3" name="radio-group1"
                     @click="toggleSelectAll" :checked="selectAllActive">
              <label for="option3">Alles selecteren</label>
            </p>

            <!-- Age Selection Options -->
            <p class="mt-2">
              <input type="radio" id="option1" name="radio-group" v-model="isChecked1"
                     :value="true">
              <label for="option1">Ik ben 18 jaar of ouder</label>
            </p>
            <p class="mt-2">
              <input type="radio" id="option2" name="radio-group" v-model="isChecked2"
                     :value="true">
              <label for="option2">Ik ben jonger dan 18 jaar <br>en heb toestemming van mijn ouders</label>
            </p>
            <div v-if="!this.validAgeConsent" class="error_msg">Bevestig je leeftijd</div>

            <!-- Terms Checkbox -->
            <div class="check">
              <input type="checkbox" id="terms" v-model="termsConsent">
              <label for="terms">Ik ga akkoord met de
                <a href="static/docs/Actievoorwaarden.pdf" target="_blank">Actievoorwaarden</a>
              </label>
            </div>
            <div v-if="!this.validTermsConsent" class="error_msg">Accepteer de Actievoorwaarden om
              door te gaan
            </div>

            <!-- Marketing Consent Checkbox - Only show if user hasn't already provided marketing consent -->
            <div class="check" v-if="!hasAlreadyGivenMarketingConsent">
              <input type="checkbox" id="privacy" class="termsCheckbox" v-model="marketingConsent">
              <label for="privacy">
                Odido mag mij op basis van mijn verbruiks- en persoonsgegevens persoonlijk advies geven en passende aanbiedingen sturen per sms. Zo kunnen we je tips geven over je dataverbruik of over het aanpassen van je bundels.
              </label>
            </div>
          </form>
        </div>
        <div class="modal-footer">
          <button type="button" @click="submitConsents" class="black_btn step1">Bevestigen
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import gameFlow from '../../common/mixin/gameFlow'
import gtm_analytics from "../../common/mixin/gtm_analytics";

export default {
  name: 'AcceptTermsPopUp',
  mixins: [
    gameFlow,
    gtm_analytics
  ],
  data() {
    return {
      isChecked1: false,
      isChecked2: false,
      ageConsent: false,
      termsConsent: false,
      marketingConsent: false,
      selectAllActive: false,
      validAgeConsent: true,
      validTermsConsent: true
    }
  },
  mounted() {
    $('#accept_TC_popup').modal('show')
    this.pushPopUp('Popup visit', 'Accept TC Pop Up')
    this.checkUserMarketingConsent()
  },
  computed: {
    ...mapGetters([
      'getIsCodeValidForRedeem',
      'getRedemptionMsisdn',
      'getCheckMarketingConsentResponse'
    ]),
    hasAlreadyGivenMarketingConsent() {
      return this.getCheckMarketingConsentResponse &&
        this.getCheckMarketingConsentResponse.result === 'SUCCESS' &&
        this.getCheckMarketingConsentResponse.hasGivenMarketingConsent === true
    }
  },
  methods: {
    ...mapMutations([
      'updateAcceptTermsModal',
      'updateGameFlowState',
      'updateGameResponse',
      'updateTopUpValue',
      'updateIsCodeValidForRedeem'
    ]),
    ...mapActions([
      'redeemCode',
      'updateMarketingConsent',
      'checkExistingMarketingConsent'
    ]),

    // Toggle "Alles selecteren" functionality -  Selects: Age 18+, Terms, Marketing (but NOT under-18 option)
    toggleSelectAll() {
      if (this.selectAllActive) {
        // Currently active → deselect everything
        this.isChecked1 = false // Age 18+ off
        this.isChecked2 = false // Under 18 off
        this.termsConsent = false // Terms off
        this.marketingConsent = false // Marketing off
        this.selectAllActive = false // Select all off
      } else {
        // Currently inactive → select specific options
        this.isChecked1 = true // Age 18+ ON
        this.isChecked2 = false // Under 18 stays OFF
        this.termsConsent = true // Terms ON

        // Only select marketing if user hasn't already consented
        if (!this.hasAlreadyGivenMarketingConsent) {
          this.marketingConsent = true // Marketing ON
        }

        this.selectAllActive = true // Select all ON
      }
    },

    // Check if user already has marketing consent
    checkUserMarketingConsent() {
      this.checkExistingMarketingConsent({
        msisdn: this.getRedemptionMsisdn
      })
        .catch((error) => {
          console.error('Error checking marketing consent:', error)
        })
    },

    // Save marketing consent when form is submitted
    saveMarketingConsent() {
      if (this.marketingConsent && !this.hasAlreadyGivenMarketingConsent) {
        this.updateMarketingConsent({
          msisdn: this.getRedemptionMsisdn
        })
          .catch((error) => {
            console.error('Error updating marketing consent:', error)
          })
      }
    },

    closeModal() {
      this.updateAcceptTermsModal(false)
      this.resetFields()
    },

    submitConsents() {
      if (this.isChecked1 || this.isChecked2) {
        this.ageConsent = true
      }

      this.validAgeConsent = this.ageConsent
      this.validTermsConsent = this.termsConsent

      if (this.validAgeConsent && this.validTermsConsent) {
        this.saveMarketingConsent()
        this.redeemCode()
          .then((response) => {
            this.loadInfoFromConversation(response)
            this.$store.commit('updateAcceptTermsModal', false)
            this.$store.commit('updateIsCodeValidForRedeem', true)
            $('#accept_TC_popup').modal('hide')
            this.gameRouting()
          })
          .catch((error) => {
            this.$store.commit('updateIsCodeValidForRedeem', false)
            this.$store.commit('updateAcceptTermsModal', false)
            $('#accept_TC_popup').modal('hide')
            this.$store.commit('updatePlayGameModal', true)
            $('#play_now_popup').modal('show')
            console.log('an error occurred: ' + error)
            this.disabled = false
          })
      }
    },
    resetFields() {
      this.isChecked1 = false
      this.isChecked2 = false
      this.termsConsent = false
      this.marketingConsent = false
      this.selectAllActive = false
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/modals/AcceptTermsPopUp.vue